// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"JO-z","carouselContainer":"KO-z"};